import { createProfileTW } from 'flow/actions/profile-actions';
import useAppContext from 'flow/hooks/useAppContext';
import useContact from 'flow/hooks/useContact';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { PriorityItems } from 'flow/utils/profile-utils';
import { fromJS } from 'immutable';
import React, { useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import SettingSection from '../Setting/SettingSection';
import BaseModal from '../ui-components/BaseModal';
import ContactAvatar from '../ui-components/ContactAvatar';
import Divider from '../ui-components/Divider';
import InputField from '../ui-components/InputField';
import RadioButton from '../ui-components/RadioButton';

interface Props {
    extensionKey?: ExtensionKey;
}

const CreateFlowFreeProfileModal = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { ownContact } = useContact(extensionKey);

    const [name, setName] = useState('');
    const [status, setStatus] = useState<'available' | 'unavailable'>(
        'available',
    );

    return (
        <BaseModal
            open={true}
            header={i18next.t('settings.profile.create_new_profile')}
            disableSubmit={!name}
            onSubmit={() => {
                dispatch(
                    createProfileTW(
                        extensionKey,
                        fromJS({
                            description: name,
                            available: status === 'available',
                            defaultDuration: '0',
                            priority: PriorityItems[50].key,
                        }),
                    ),
                );
            }}
            confirmButtonText={i18next.t('settings.profile.create_button')}
            className="w-[600px]"
        >
            <div className="flex flex-col px-2">
                <SettingSection>
                    {i18next.t('settings.profile.wizard.name')}
                </SettingSection>

                <InputField
                    placeholder={i18next.t('settings.profile.name_field_hint')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <Divider />

                <SettingSection>
                    {i18next.t('settings.profile.wizard.status')}
                </SettingSection>

                <div className="flex items-center justify-between">
                    <div className="flex flex-1 flex-col">
                        <RadioButton
                            name="status"
                            checked={status === 'available'}
                            onChange={() => setStatus('available')}
                        >
                            {i18next.t('status.available')}
                        </RadioButton>

                        <RadioButton
                            name="status"
                            checked={status === 'unavailable'}
                            onChange={() => setStatus('unavailable')}
                        >
                            {i18next.t('status.unavailable')}
                        </RadioButton>
                    </div>

                    <div>
                        <ContactAvatar
                            contact={ownContact}
                            status={status}
                            size="large"
                        />
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};

export default CreateFlowFreeProfileModal;
